import { useStatsig } from '@atlassian/mpac-feature-flags';
import React from 'react';
import SearchResultPageLegacy from './SearchResultPageLegacy';
import SearchResultPageWithAtlassianApps from './SearchResultPageWithAtlassianApps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Entry point for Search Result Page
 * Routes to either legacy or new UI based on experiment flag
 */
const SearchResultPage = props => {
  const {
    enableAtlassianAppsInEmbeddedMarketplace
  } = useStatsig();
  const enableAtlassianAppsExperiment = enableAtlassianAppsInEmbeddedMarketplace({
    fireExperimentExposure: Boolean(props.isAtlassianAppsExpEnabled)
  });
  const useAtlassianAppsExperimentNewUI = props.isAtlassianAppsExpEnabled && enableAtlassianAppsExperiment === 'test';
  return useAtlassianAppsExperimentNewUI ? /*#__PURE__*/_jsx(SearchResultPageWithAtlassianApps, {
    isAppInstalled: props.isAppInstalled,
    cloudId: props.cloudId
  }) : /*#__PURE__*/_jsx(SearchResultPageLegacy, {
    isAppInstalled: props.isAppInstalled
  });
};
export default SearchResultPage;